import React, { useEffect, useRef } from 'react';
import { DropdownItem } from 'reactstrap';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useDropdown } from '..';

export default function DropdownOption({
  isActive = false,
  disabled = false,
  onClick = () => {},
  className = '',
  children = null
}) {
  return (
    <DropdownItem
      isActive={isActive}
      disabled={disabled}
      onClick={onClick}
      className={className}
      tag={Item}
    >
      {children}
    </DropdownItem>
  );
}

function Item({
  isActive = false,
  disabled = false,
  onClick = () => {},
  className = '',
  children = null,
  ...props
}) {
  const { isOpen, disabled: isDisabled } = useDropdown();

  const buttonRef = useRef(null);
  const isItemDisabled = disabled || isDisabled;

  useEffect(() => {
    if (isOpen && buttonRef.current && isActive) {
      buttonRef.current.focus();
    }
  }, [isOpen, isActive]);

  const onSelect = () => !isItemDisabled && onClick();

  return (
    <UiKit.Button
      {...props}
      innerRef={buttonRef}
      variant="outline"
      onClick={onSelect}
      disabled={isItemDisabled}
      data-active={isActive}
      className={cn(styles.container, className)}
    >
      {children}
    </UiKit.Button>
  );
}
